import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../Services/_states';

const ProtectedRoute = ({ element, permissionGranted }) => {
  const auth = useRecoilValue(authAtom);
  if (!auth?.token) {
    return <Navigate to="/r/login" replace />;
  }
  if (!permissionGranted) {
    return <Navigate to="/r/404" replace />;
  }
  return element;
};

export default ProtectedRoute;
